import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextEditorComponent } from './component/text-editor';
import { QuillModule } from 'ngx-quill';
import { FormsModule } from '@angular/forms';
import { DsSpinnerModule } from '@skyeng/libs/shared/ui-kit-v2/spinner';

@NgModule({
  declarations: [TextEditorComponent],
  imports: [CommonModule, QuillModule, FormsModule, DsSpinnerModule],
  exports: [TextEditorComponent, QuillModule],
})
export class TextEditorModule {}
